import { gql } from '@apollo/client';

// ====================== QUERY ====================== //
const QUERY_ITEM = gql`
    query brand($input: BrandInput!){
        brand(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const QUERY_ITEMS = gql`
    query brands($input: BrandsInput){
        brands(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const QUERY_LOOKUP_ITEMS = gql`
    query brands($input: BrandsInput){
        brands(input: $input){
            # id
            uuid
            code
            name
            company
            # created_at
            # created_by
            # updated_at
            # updated_by
        }
    }
`
const QUERY_ITEMS_BY_PAGE = gql`
    query brandsByPage($input: BrandsByPageInput!){
        brandsByPage(input: $input){
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
            currentPage
            prevPage
            nextPage
            totalPages
            totalItems
            brands{
                id
                uuid
                code
                name
                company
                created_at
                created_by
                updated_at
                updated_by
            }
        }
    }
`
// ====================== MUTATION ====================== //
const MUTATION_CREATE_ITEM = gql`
    mutation createBrand($input: CreateBrandInput!){
        createBrand(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const MUTATION_CREATE_ITEMS = gql`
    mutation createBrands($input: [CreateBrandInput]!){
        createBrands(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const MUTATION_DELETE_ITEM = gql`
    mutation deleteBrand($input: DeleteBrandInput!){
        deleteBrand(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const MUTATION_DELETE_ITEMS = gql`
    mutation deleteBrands($input: DeleteBrandInput!){
        deleteBrands(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`
const MUTATION_EXPORT_ITEMS = gql`
    mutation exportBrands($input: BrandsInput!, $by: ActionByInput!){
        exportBrands(input: $input, by: $by){
           uuid
           size
           key
           name
           status
           topic
           type
           url
           company
           created_at
           created_by
           updated_at
           updated_by
        }
    }
`
const MUTATION_UPDATE_ITEM = gql`
    mutation updateBrand($input: UpdateBrandInput!){
        updateBrand(input: $input){
            id
            uuid
            code
            name
            company
            created_at
            created_by
            updated_at
            updated_by
        }
    }
`

// ====================== CREATE GQL ====================== //
const brandGQL = {
    query: {
        getItem: QUERY_ITEM,
        getItems: QUERY_ITEMS,
        getLookupItems: QUERY_LOOKUP_ITEMS,
        getItemsByPage: QUERY_ITEMS_BY_PAGE,
    },
    mutation: {
        createItem: MUTATION_CREATE_ITEM,
        createItems: MUTATION_CREATE_ITEMS,
        deleteItem: MUTATION_DELETE_ITEM,
        deleteItems: MUTATION_DELETE_ITEMS,
        exportItems: MUTATION_EXPORT_ITEMS,
        updateItem: MUTATION_UPDATE_ITEM,
    },
    response: {
        getItem: "brand",
        getItems: "brands",
        getLookupItems: "brands",
        getItemsByPage: "brandsByPage",
        createItem: "createBrand",
        createItems: "createBrands",
        deleteItem: "deleteBrand",
        deleteItems: "deleteBrands",
        exportItems: "exportBrands",
        updateItem: "updateBrand",
    }
}

// ====================== EXPORT ====================== //
export {
    brandGQL,
}